import { axiosInstance } from "./axiosInstance";

class CommonService {
  async get(url) {
    return new Promise(async function (resolve, reject) {
      await axiosInstance({
        method: "get",
        url: url,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err)
        });
    });
  }

  async delete(url) {
    try {
      const result = await axiosInstance({
        method: "delete",
        url: url,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      return result;
    } catch (err) {

      throw err;
    }
  }

  async post(url, data) {
    try {
      const config = {
        method: "post",
        url,
        data,
        headers: {
          Accept: "*/*",
        },
      };

      if (data instanceof FormData) {
      } else if (typeof data === 'object' && data !== null) {
        config.headers["Content-Type"] = "application/json";
      } else {
        config.headers["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
      }
      const result = await axiosInstance(config);
      return result;
    } catch (error) {
      throw error;
    }
  }

  async put(url, data) {
    return new Promise(async function (resolve, reject) {
      await axiosInstance({
        method: "put",
        url: url,
        data,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json; charset=utf-8",
        },
      })
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err)
        });
    });
  }


}

const commonServiceInstance = new CommonService()

export default commonServiceInstance;
